import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';
import CardBox from '../../MisVisitasCreation/components/components/CardBox/CardBox';
import InfoRow from '../../MisVisitasCreation/components/components/InfoRow/InfoRow';

export const CabeceraControlVisita = ({ data }) => {
    return (
        <CardBox className='cabecera-control-visita'>
            <Accordion disableGutters elevation={0} square sx={{ backgroundColor: 'inherit', '&:before': { display: 'none', }, }}>
                <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    sx={{
                        paddingY: 0,
                        backgroundColor: 'inherit',
                        minHeight: 'auto',
                        '& .MuiAccordionSummary-content': {
                            margin: 0,
                        },
                    }}
                >
                    <Grid container item size={{ xs: 12, md: 12, lg: 12 }}><strong>Información</strong></Grid>
                </AccordionSummary>
                <AccordionDetails sx={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'inherit', }}>
                    <Grid container columnSpacing={2} rowSpacing={1}>
                        <Grid container item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Grid item sx={{ py: '10px' }} size={{ xs: 12, md: 12, lg: 12 }}><strong>Paciente</strong></Grid>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <InfoRow invert={true} label="Nombre" value={data?.paciente} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <InfoRow invert={true} label="Paciente Nuevo" value={data?.pacienteNuevo} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <InfoRow invert={true} label="Estado" value={data?.estadoPaciente} />
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid container columnSpacing={2} rowSpacing={1} size="grow">
                        <Grid container item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Grid item sx={{ padding: '10px 0' }} size={{ xs: 12, md: 12, lg: 12 }}><strong>Contrato</strong></Grid>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 1 }}>
                            <InfoRow invert={true} label="#" value={data?.idEvaluacion} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
                            <InfoRow invert={true} label="Profesional" value={data?.profesional} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
                            <InfoRow invert={true} label="Fecha Asignación" value={data?.fechaAsignacion} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 1 }}>
                            <InfoRow invert={true} label="Programa" value={data?.programa} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
                            <InfoRow invert={true} label="Plan" value={data?.planCuidado} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
                            <InfoRow invert={true} label="Frecuencia del Plan" value={data?.frecuenciaPlan} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
                            <InfoRow invert={true} label="Frecuencia" value={data?.frecuencia} />
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid container columnSpacing={2} rowSpacing={1} size="grow">
                        <Grid container item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Grid item sx={{ padding: '10px 0' }} size={{ xs: 12, md: 12, lg: 12 }}><strong>Visitas</strong></Grid>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <InfoRow invert={true} label="Visitas Programadas" value={`${data?.visitasRealizadas} / ${data?.visitasEstimadas}`} />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <InfoRow invert={true} label="Urgencias" value={data?.cantidadUrgencias} />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </CardBox>
    );
}